import State from '../utils/state';

export default {
    computed: {
        postalCodeName () {
            return this.state.appRegion === 'us' ? 'Zip' : 'Postal';
        }
    },

    data () {
        return {
            state: State
        };
    }
};
